module.exports = __webpack_public_path__ + "static/media/FolderRedDark.24541d36.svg";